import { featuresData } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          平台特色
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          为什么选择黑料官网作为你的娱乐资讯入口
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
          {featuresData.map((feature) => (
            <div
              key={feature.id}
              className="flex flex-col items-center text-center p-6 bg-background-50 border border-background-200/60 rounded-lg"
            >
              <span className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 mb-4">
                <i className={`${feature.icon} text-2xl`}></i>
              </span>
              <h3 className="text-base md:text-lg font-semibold text-foreground-950 mb-3">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}